import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import api from '../utils/api'

const Enroll = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [course, setCourse] = useState<any>(null)
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    reason: ''
  })
  const [privacyConsents, setPrivacyConsents] = useState([
    { consent_type: '필수', is_required: true, is_agreed: false }
  ])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadCourse()
  }, [id])

  const loadCourse = async () => {
    try {
      const response = await api.get(`/courses/${id}`)
      setCourse(response.data)
    } catch (error) {
      console.error('강의 로드 오류:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    // 필수 동의 확인
    const requiredConsents = privacyConsents.filter(c => c.is_required)
    if (!requiredConsents.every(c => c.is_agreed)) {
      alert('필수 개인정보 동의 항목에 모두 동의해주세요.')
      return
    }

    try {
      await api.post('/enrollments', {
        courseId: parseInt(id!),
        ...formData,
        privacyConsents: privacyConsents.filter(c => c.is_agreed)
      })
      alert('수강신청이 완료되었습니다.')
      navigate('/my-enrollments')
    } catch (error: any) {
      alert(error.response?.data?.error || '수강신청에 실패했습니다.')
    }
  }

  if (loading) {
    return <div className="container"><div className="loading">로딩 중...</div></div>
  }

  if (!course) {
    return <div className="container"><div className="alert alert-error">강의를 찾을 수 없습니다.</div></div>
  }

  return (
    <div className="container">
      <h1 style={{ marginBottom: '20px' }}>수강신청</h1>
      
      <div className="card" style={{ marginBottom: '20px' }}>
        <h3>{course.title}</h3>
        <p><strong>교수:</strong> {course.instructor}</p>
        <p><strong>학점:</strong> {course.credits}학점</p>
        <p><strong>일정:</strong> {course.schedule}</p>
        <p><strong>학년도/계절:</strong> {course.year}년 {course.season}</p>
      </div>

      <div className="card">
        <h3 style={{ marginBottom: '20px' }}>신청자 정보</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>성명 *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label>전화번호</label>
            <input
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>이메일</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>결의근거</label>
            <textarea
              value={formData.reason}
              onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
              rows={4}
            />
          </div>

          <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <h4>개인정보 수집·이용 동의</h4>
            {privacyConsents.map((consent, index) => (
              <div key={index} style={{ marginBottom: '10px' }}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={consent.is_agreed}
                    onChange={(e) => {
                      const newConsents = [...privacyConsents]
                      newConsents[index].is_agreed = e.target.checked
                      setPrivacyConsents(newConsents)
                    }}
                    style={{ marginRight: '10px' }}
                  />
                  <span>
                    {consent.consent_type} 개인정보 수집·이용 동의
                    {consent.is_required && <span style={{ color: 'red' }}> *</span>}
                  </span>
                </label>
              </div>
            ))}
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
            수강신청
          </button>
        </form>
      </div>
    </div>
  )
}

export default Enroll


